import React, { useId } from 'react';
import { IconSparkles } from '@tabler/icons-react';

const GradientSparklesIcon = ({ size = 20, stroke = 1.75 }) => {
  const gradientId = useId();

  return (
    <IconSparkles
      size={size}
      stroke={stroke}
      color={`url(#${gradientId})`}
      aria-hidden="true"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="18.7706"
          y1="12.5781"
          x2="1.66666"
          y2="12.5781"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2E54A6" />
          <stop offset="0.5" stopColor="#068CF2" />
          <stop offset="1" stopColor="#C6D41F" />
        </linearGradient>
      </defs>
    </IconSparkles>
  );
};

export default GradientSparklesIcon;